import styled, { css } from 'styled-components';
import { ButtonOptions } from '../ButtonOptions';
import { colors, radius } from '../../styles/tokens';

interface containerProps {
  currentSubscription?: boolean;
}

export const Title = styled.h2`
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.onSurfaceVariant};
  text-align: left;
`;

export const Container = styled.div<containerProps>`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: 100%;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};

  display: flex;
  flex-direction: column;

  padding: 28px;

  border: 2px solid transparent;
  transition: transform 0.2s, border-color 0.2s;

  &:hover {
    transform: translateY(-4px);
  }

  ${props =>
    props.currentSubscription &&
    css`
      border: 2px solid ${colors.primary};
      box-shadow: 0 0 30px ${colors.primary}26;

      ${Title} {
        color: ${colors.primary};
      }
    `}
`;

export const BackgroundIcon = styled.div`
  position: absolute;
  top: -16px;
  right: -16px;

  opacity: 0.06;
  pointer-events: none;
`;

export const CurrentTag = styled.span`
  position: absolute;
  top: 0;
  right: 0;

  padding: 6px 16px;
  border-bottom-left-radius: ${radius.md};

  background-color: ${colors.primary};
  color: ${colors.onPrimary};

  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const ContainerTitle = styled.div`
  margin-bottom: 20px;
`;

export const ContainerInfo = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 20px 0;

  border-top: 1px solid ${colors.outlineVariant}40;
  border-bottom: 1px solid ${colors.outlineVariant}40;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 14px;

  width: 100%;

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & > span {
    color: ${colors.onSurface};
    font-weight: 600;
  }
`;

export const ContainerPrice = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: 20px;
`;

export const Price = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;

  span {
    font-size: 13px;
    color: ${colors.primary};
    font-weight: 700;

    &.price {
      font-size: 40px;
      font-weight: 800;
      color: ${colors.onSurface};
      letter-spacing: -0.02em;
      margin: 0px 5px;
    }

    &:last-child {
      color: ${colors.onSurfaceVariant};
      font-weight: 400;
    }
  }
`;

export const Button = styled(ButtonOptions)`
  width: 100%;
`;
